const categoryCards = [
  {
    name: "Shoes",
    description: "Latest sneakers & footwear finds",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Colorful%20retro%20running%20sneakers%20on%20light%20mint%20green%20textured%20surface%2C%20editorial%20product%20photography%2C%20bright%20natural%20daylight%2C%20vibrant%20fresh%20composition%2C%20sporty%20aesthetic&width=800&height=600&seq=cat-v2-shoes&orientation=landscape",
    alt: "AcBuy Spreadsheet Shoes category",
  },
  {
    name: "Hoodies/Sweaters",
    description: "Cozy streetwear & premium hoodies",
    url: "https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html",
    image: "https://readdy.ai/api/search-image?query=Oversized%20charcoal%20grey%20hoodie%20with%20visible%20texture%20on%20light%20oak%20wooden%20floor%2C%20editorial%20fashion%20photography%2C%20warm%20side%20lighting%2C%20cozy%20minimalist%20composition%2C%20premium%20fabric%20detail&width=800&height=600&seq=cat-v2-hoodies&orientation=landscape",
    alt: "AcBuy Spreadsheet Hoodies Sweaters category",
  },
  {
    name: "T-Shirts",
    description: "Essential tees & graphic prints",
    url: "https://kaspreadsheet.com/category-913-T-Shirts.html",
    image: "https://readdy.ai/api/search-image?query=Pastel%20colored%20cotton%20t-shirts%20neatly%20stacked%20on%20white%20marble%20surface%2C%20product%20photography%2C%20bright%20studio%20lighting%2C%20clean%20minimalist%20composition%2C%20soft%20fabric%20textures&width=800&height=600&seq=cat-v2-tshirts&orientation=landscape",
    alt: "AcBuy Spreadsheet T-Shirts category",
  },
  {
    name: "Jackets",
    description: "Bombers, denim & outerwear",
    url: "https://kaspreadsheet.com/category-914-Jackets.html",
    image: "https://readdy.ai/api/search-image?query=Vintage%20wash%20denim%20jacket%20draped%20on%20terracotta%20colored%20wall%20background%2C%20editorial%20fashion%20photography%2C%20dramatic%20shadow%20lighting%2C%20urban%20minimalist%20composition&width=800&height=600&seq=cat-v2-jackets&orientation=landscape",
    alt: "AcBuy Spreadsheet Jackets category",
  },
  {
    name: "Pants/Shorts",
    description: "Cargo, jeans & everyday bottoms",
    url: "https://kaspreadsheet.com/category-915-Pants%2FShorts.html",
    image: "https://readdy.ai/api/search-image?query=Olive%20green%20cargo%20pants%20flatlay%20on%20light%20grey%20concrete%20surface%2C%20product%20photography%2C%20soft%20natural%20daylight%2C%20utilitarian%20minimalist%20composition%2C%20texture%20detail&width=800&height=600&seq=cat-v2-pants&orientation=landscape",
    alt: "AcBuy Spreadsheet Pants Shorts category",
  },
  {
    name: "Headwear",
    description: "Caps, beanies & bucket hats",
    url: "https://kaspreadsheet.com/category-916-Headwear.html",
    image: "https://readdy.ai/api/search-image?query=Three%20different%20style%20caps%20and%20beanies%20on%20light%20blush%20pink%20surface%2C%20editorial%20product%20photography%2C%20soft%20evening%20light%2C%20modern%20minimalist%20composition%2C%20accessories%20flatlay&width=800&height=600&seq=cat-v2-headwear&orientation=landscape",
    alt: "AcBuy Spreadsheet Headwear category",
  },
  {
    name: "Sets",
    description: "Coordinated tracksuits & matching sets",
    url: "https://kaspreadsheet.com/category-917-Sets.html",
    image: "https://readdy.ai/api/search-image?query=Matching%20sweatsuit%20set%20in%20warm%20taupe%20color%20folded%20on%20light%20sand%20textured%20surface%2C%20editorial%20fashion%20photography%2C%20soft%20diffused%20lighting%2C%20clean%20minimalist%20composition&width=800&height=600&seq=cat-v2-sets&orientation=landscape",
    alt: "AcBuy Spreadsheet Sets category",
  },
  {
    name: "Underwear/Underpants",
    description: "Comfort essentials & basics",
    url: "https://kaspreadsheet.com/category-918-underwear%2Funderpants.html",
    image: "https://readdy.ai/api/search-image?query=Soft%20organic%20cotton%20basics%20neatly%20rolled%20on%20white%20linen%20textured%20surface%2C%20product%20photography%2C%20bright%20clean%20daylight%2C%20minimalist%20wellness%20aesthetic%2C%20fresh%20composition&width=800&height=600&seq=cat-v2-underwear&orientation=landscape",
    alt: "AcBuy Spreadsheet Underwear Underpants category",
  },
  {
    name: "Jersey",
    description: "Sports jerseys & athletic wear",
    url: "https://kaspreadsheet.com/category-919-Jersey.html",
    image: "https://readdy.ai/api/search-image?query=Basketball%20jersey%20and%20shorts%20flatlay%20on%20dark%20charcoal%20grey%20textured%20surface%2C%20sports%20product%20photography%2C%20dramatic%20studio%20lighting%2C%20athletic%20bold%20composition&width=800&height=600&seq=cat-v2-jersey&orientation=landscape",
    alt: "AcBuy Spreadsheet Jersey category",
  },
  {
    name: "Accessories",
    description: "Watches, jewelry & extras",
    url: "https://kaspreadsheet.com/category-920-Accessories.html",
    image: "https://readdy.ai/api/search-image?query=Elegant%20gold%20watch%20and%20minimalist%20bracelets%20on%20light%20lavender%20silk%20fabric%2C%20luxury%20product%20photography%2C%20soft%20studio%20lighting%2C%20refined%20minimalist%20composition&width=800&height=600&seq=cat-v2-accessories&orientation=landscape",
    alt: "AcBuy Spreadsheet Accessories category",
  },
  {
    name: "Bags",
    description: "Backpacks, totes & crossbody bags",
    url: "https://kaspreadsheet.com/category-921-Bags.html",
    image: "https://readdy.ai/api/search-image?query=Stylish%20canvas%20backpack%20and%20leather%20tote%20on%20light%20sage%20green%20surface%2C%20editorial%20product%20photography%2C%20natural%20daylight%2C%20modern%20minimalist%20composition%2C%20lifestyle%20aesthetic&width=800&height=600&seq=cat-v2-bags&orientation=landscape",
    alt: "AcBuy Spreadsheet Bags category",
  },
  {
    name: "Belts",
    description: "Designer belts & accessories",
    url: "https://kaspreadsheet.com/search-922/name/Bags.html",
    image: "https://readdy.ai/api/search-image?query=Premium%20brown%20leather%20belt%20with%20brass%20buckle%20on%20dark%20slate%20textured%20surface%2C%20luxury%20product%20photography%2C%20dramatic%20directional%20lighting%2C%20elegant%20minimal%20composition&width=800&height=600&seq=cat-v2-belts&orientation=landscape",
    alt: "AcBuy Spreadsheet Belts category",
  },
  {
    name: "Perfumes",
    description: "Fragrances & colognes",
    url: "https://kaspreadsheet.com/search-923/name/Bags.html",
    image: "https://readdy.ai/api/search-image?query=Three%20elegant%20glass%20perfume%20bottles%20with%20different%20shapes%20on%20white%20marble%20surface%2C%20luxury%20product%20photography%2C%20soft%20studio%20lighting%20with%20reflections%2C%20sophisticated%20composition&width=800&height=600&seq=cat-v2-perfumes&orientation=landscape",
    alt: "AcBuy Spreadsheet Perfumes category",
  },
  {
    name: "Other Stuff",
    description: "Everything else you need",
    url: "https://kaspreadsheet.com/search-924/name/Bags.html",
    image: "https://readdy.ai/api/search-image?query=Assorted%20lifestyle%20products%20including%20sunglasses%20wallet%20and%20gadgets%20flatlay%20on%20light%20cream%20textured%20surface%2C%20editorial%20photography%2C%20bright%20natural%20light%2C%20organized%20eclectic%20composition&width=800&height=600&seq=cat-v2-otherstuff&orientation=landscape",
    alt: "AcBuy Spreadsheet Other Stuff category",
  },
];

export default function CategoryGrid() {
  return (
    <section className="py-20 md:py-28 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <span className="inline-block text-xs font-medium text-foreground-500 tracking-widest uppercase mb-3">
            Browse Categories
          </span>
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-900 leading-tight mb-4">
            Shop Categories
          </h2>
          <p className="text-base md:text-lg text-foreground-600 max-w-2xl mx-auto">
            Browse our curated collection of trusted fashion finds across every category. Each link takes you directly to verified product listings.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {categoryCards.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group relative rounded-2xl overflow-hidden h-60 md:h-72 cursor-pointer"
            >
              <img
                src={cat.image}
                alt={cat.alt}
                title={`AcBuy Spreadsheet ${cat.name}`}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                <h3 className="text-xl md:text-2xl font-heading font-bold text-white mb-1">
                  {cat.name}
                </h3>
                <p className="text-sm text-white/80">
                  {cat.description}
                </p>
                <span className="inline-block mt-3 text-sm font-medium text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  Shop Now <i className="ri-arrow-right-line ml-1"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}